<template>
  <div class="commodity_details_box">
    <div class="cloud_bread">
      <span>当前位置：</span>
      <span class="cursor allHover" @click="backShop">所有</span>&nbsp;<i
        class="el-icon-arrow-right"
      ></i
      >&nbsp;<span>{{ supplier_name }}</span>
    </div>
    <div class="goods_contend_box">
      <div class="contend_left_box">
        <!-- <div class="VR_box" @click="toLink" v-show="isVR">
          <img src="../../assets/icon_share@2x.png" alt="" /><span>VR</span>
        </div> -->
        <div class="img_box">
          <img :src="`${imgUrl}?x-oss-process=image/resize,m_lfit,h_420,w_420`" alt="" />
        </div>
        <div class="img_indicator_box">
          <ul>
            <li
              :class="{ 'img_indicator-item': true, selected: imgId == item.id }"
              v-for="item in imgArr"
              :key="item.id"
              @click="imgClick(item)"
            >
              <img
                :src="`${item.url}?x-oss-process=image/resize,m_lfit,h_50,w_50`"
                alt=""
              />
            </li>
          </ul>
        </div>
      </div>
      <div class="contend_middle_box">
        <div class="commodity-info">
          <div class="commodity-info__name flex-2">
            <span>
              {{ this.supplier_name }}
            </span>
            <!-- <span class="to-order-fb" @click="toOrderFB" v-if="type != 'edge'"> 订购配套封边条 </span> -->
          </div>
          <div class="commodity-info__inventory">
            <img src="../../assets/icon_location@2x.png" width="12" alt="位置" />
            {{ brand_name }}
            <span class="zy"> 自营 </span>
          </div>
          <div class="commodity-info__price">
            <span class="label">{{ isVip ? "会员价" : "价格" }}</span>
            <span class="red">
              <span style="font-size: 10px">￥</span>
              <span class="price">
                {{ getPriceSection }}
              </span>
              <span v-if="isVip" style="font-size: 10px;color: #333">
                预计优惠 <span class="red">{{ getDiscounts }}</span> 元起
              </span>
            </span>
          </div>
          <div class="commodity-info__item">
            <span class="label">品牌</span>
            <span class="content">
              {{ brand_name }}
            </span>
          </div>
          <div class="commodity-info__item">
            <span class="label">备注</span>
            <span class="content">
              {{ remark }}
            </span>
          </div>
        </div>



        <div class="commodity-list" v-if="this.com_type ==='shutter' ">
          <el-table
            :data="commodityList"
            header-cell-class-name="table-header"
            border
            :header-cell-style="{ background: '#f5f5f5' }"
            cell-class-name="table-cell"
            @row-click="handleRowClick"
          >
            <el-table-column
              v-for="(item, index) in getCommodityColumn"
              :key="index"
              :label="item.label"
              :prop="item.prop"
            >
              <template slot-scope="scope">
                <span v-if="item.template">
                  {{ item.template(scope.row) }}
                </span>
                <span v-else>
                  {{ scope.row[item.prop] || 0 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="订购数量">
              <template slot-scope="scope">
                <!-- <el-input-number
                  size="mini"
                  v-model="scope.row.count"
                  :min="0"
                >
                </el-input-number> -->
                <el-input-number
                  size="mini"
                  v-model="productCount"
                  :min="0"
                >
                </el-input-number>
              </template>
            </el-table-column>
          </el-table>
          <button class="button_three_d" @click="commodityDetails()">查看3D模型</button>
        </div>
        <div v-else>
            <el-input-number
            size="mini"
            v-model="productCount"
            :min="0"
          >
          </el-input-number>
        </div>
        <!-- <div class="footer-hint">
          <span>
            订购：1.密度/ 规格:1220*2800/ 厚度:18/ 贴面工艺:附贴*1；2.基材：密度/
            规格:1220*2400/ 厚度:18/ 贴面工艺:直 贴
          </span>
        </div> -->



        <!-- <el-input-number
          size="mini"
          v-model="productCount"
          :min="0"
        >
        </el-input-number> -->
        <div class="control-btns">
          <button class="to-cart" @click="toShopCart">查看购物车</button>
          <button class="addto-cart" @click="addToCart">加入购物车</button>
        </div>
      </div>
      <div class="contend_right_box">
        <div class="supplier_box contend_right_width">
          <div><img :src="supplierMessage.avatar" alt="" /></div>
          <div>
            <span>{{ supplierMessage.name }}</span>
            <span class="cursor" @click="toSupplierDetails">所有价格表</span>
          </div>
        </div>
        <div class="supplier_message_box contend_right_width">
          <div>
            <span>地址：</span><span>{{ supplierMessage.address }}</span>
          </div>
          <div>
            <span>简介：</span><span>{{ supplierMessage.content }}</span>
          </div>
          <div>
            <span>电话：</span><span>{{ supplierMessage.phone }}</span>
          </div>
        </div>
        <div class="supplier_goods_box">
          <div>
            <span>商品</span>
            <span>{{ supplierMessage.goods_count }}</span>
          </div>
          <div class="border_box"></div>
          <div>
            <span>画册色卡</span>
            <span>{{ supplierMessage.albums_count }}</span>
          </div>
        </div>
        <div class="to_shop_box cursor">
          <div>进入店铺</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goodsFilter from "../../util/goodsFilter"; //处理商品列表获取基础规格和选完规格后获取对应商品的信息
import { shopCarInfoNormalize } from "../../util/processingData";
import { mapState } from "vuex";

/**
 * 除购买数量栏外所有column
 * @param {boolean} isVip
 */
const commodityColumns = (isVip) => ({
  cabinet: [
    {
      prop: "name",
      label: "名称",
    },
    {
      prop: "num",
      label: "库存",
    },
    {
      prop: isVip ? "vip_price" : "price",
      label: isVip ? "会员价" : "价格",
    },
  ],
  shutter: [
    {
      prop: "spec",
      label: "系列",
    },
    {
      prop: "num",
      label: "库存",
    },
    {
      prop: isVip ? "vip_price" : "price",
      label: isVip ? "会员价" : "价格",
    },
  ],
  furniture: [
    {
      prop: "name",
      label: "名称",
    },
    {
      prop: "num",
      label: "库存",
    },
    {
      prop: isVip ? "vip_price" : "price",
      label: isVip ? "会员价" : "价格",
    },
  ],
  woodenDoor: [
    {
      prop: "name",
      label: "名称",
    },
    {
      prop: "num",
      label: "库存",
    },
    {
      prop: isVip ? "vip_price" : "price",
      label: isVip ? "会员价" : "价格",
    },
  ],
  other: [
    {
      prop: "name",
      label: "名称",
    },
    {
      prop: "num",
      label: "库存",
    },
    {
      prop: isVip ? "vip_price" : "price",
      label: isVip ? "会员价" : "价格",
    },
  ]
});

export default {
  data() {
    return {
      productCount: 0,
      goodsIds: "",
      sid: "",
      targetKey: "", // 用于指示本次选择的是哪个属性，方便更新属性列表时，不对本次所选属性进行可选状态改变
      com_type: "",
      color_id: "",
      model_link: "",
      supplier_name:"",
      type: '',
      isVip: false,
      commodityColumns: null,
      commodityList: [],
      com_infos: {
        com_data: [],
      }, //保存该类商品信息
      imgUrl: "",
      imgId: "",
      imgArr: [],
      imgArr2: [], //非第一次非确定到某个商品展示色卡及其效果图
      brand_name: "", //默认品牌
      remark: "", //默认备注
      edge_name: "", //封边默认
      door_name: "", //门配默认名称
      attributeMessageObj: {
        //同色卡下的板材属性数据选择(无兼容)
        substrate: [],
        thick: [],
        spec: [],
        // steel_plate: [],
        texture_method: [],
      },
      mockData: {},
      supplierMessage: {}, //供应商信息
      found: true,
      link: "",
      isVR: true,
    };
  },
  computed: {
    ...mapState(["userInfo", "supplierInfo"]),
    /**
     * 获取价格区间
     */
    getPriceSection() {
      let prices = [];
      let priceKey = this.isVip ? "vip_price" : "price";
      this.commodityList.forEach((v) =>
        Array.isArray(v[priceKey])
          ? prices.push(...v[priceKey])
          : prices.push(v[priceKey])
      );
      return `${Math.min(...prices)}~${Math.max(...prices)}`;
    },
    getCommodityColumn() {
      return this.commodityColumns[this.com_type] || [];
    },
    getDiscounts() {
      let prices = [];
      let priceKey = "vip_price";
      this.commodityList.forEach((v) =>
        Array.isArray(v[priceKey])
          ? prices.push(...v[priceKey])
          : prices.push(v[priceKey])
      );
      priceKey = "price";
      this.commodityList.forEach((v) =>
        Array.isArray(v[priceKey])
          ? prices.push(...v[priceKey])
          : prices.push(v[priceKey])
      );
      return Math.max(...prices) - Math.min(...prices);
    },
  },
  watch: {
    '$route.query' : {
      deep: true,
      handler() {
        this.$router.go(0)
      }
    }
  },
  methods: {
    commodityDetails() {
      this.$router.push({
        path: 'ModelDisplay',
      })
    },
    toLink() {
      if (this.link == "") {
        this.$message("该色卡未绑定VR链接");
        return;
      }
      window.open(this.link);
    },
    backShop() {
      this.$router.go(-1);
    },
    imgClick(item) {
      if (item.id != 0) {
        this.isVR = false;
      } else {
        this.isVR = true;
      }
      this.imgId = item.id;
      this.imgUrl = item.url;
      console.log("-=----------", this.imgId);
    },
    toShopCart() {
      this.$router.push({
        name: 'personalCenterShopCar'
      });
    },
    addToCart() {
      if (this.productCount == 0) {
        this.$message.error("请至少选择一项加入购物车");
        return;
      }
      if (!this.userInfo.hasOwnProperty("id")) {
        let pageTo = encodeURIComponent(location.href);
        if (process.env.NODE_ENV == "development") {
          location.href = "http://localhost:8010/login.html?other=true&pageTo=" + pageTo;
        } else {
          location.href = "./login.html?pageTo=" + pageTo;
        }
        return;
      }
      let goods = this.commodityList.map((v) => ({
        ...v,
        part_type: this.com_type,
        pictures: v.picture,
        type: v.substrate,
        vip_price: v.vip_price,
        price: v.price,
        // ret_price: v.price,
        // price: v.vip_price,
        color: v.model_link || v.color,
        brand_name: this.brand_name,
        num: this.productCount
        // count: undefined,
      }));
      if (this.found) {
        this.$store.commit("setShopCar", {
          shopCarInfo: {
            uid: this.$store.state.userInfo.id,
            supplierId: this.sid,
            items: goods,
          },
          mode: "add",
        });
        this.open();
      } else {
        this.$message("该商品已下架,无法加入购物车");
      }
    },
    open() {
      this.$confirm("添加成功,快去购物车看看吧", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // window.location.href = 'https://www.guigui.com.cn/#/tableShopcar/'+this.supplierInfo.id
          this.$router.push({
            name: 'personalCenterShopCar',
          });
        })
        .catch(() => {});
    },
    toSupplierDetails() {
      this.$router.push({
        path: "/priceReport/" + this.sid,
      });
    },
    // toOrderFB() {
    //   this.$get(
    //     "/py/erp/get_edge_commodity",
    //     { color_id: this.color_id, supplier_id: this.sid },
    //     (res) => {
    //       console.log("order===========res=========", res.data);
    //       this.$router.push({
    //         name: 'commodityDetail',
    //         query: {
    //           goodsIds: res.data.data_list[0] ? res.data.data_list[0].ids : '',
    //           sid: this.sid
    //         }
    //       })
    //     }
    //   );
    // },
    handleRowClick(row) {
      if (row.type == 'edge') {
        this.rowHint = 
          `厚度： ${row.thick}/宽度： ${row.width}/规格： ${row.spec}/材质： ${row.material}`
      } else if (row.type == 'plank') {
        this.rowHint = 
          `基材： ${row.substrate}/规格： ${row.spec}/厚度： ${row.thick}/贴面工艺： ${row.texture_method}`
      } else if (row.type == 'hardware') {
        this.rowHint = 
          `名称： ${row.name}/颜色： ${row.color}/材质： ${row.material}/规格： ${row.spec}`
      } else if (row.type == 'other') {
        this.rowHint = 
          `名称： ${row.name}/颜色： ${row.color}/材质： ${row.material}/规格： ${row.spec}`
      } else if (row.type == 'door') {
        this.rowHint = 
          `材质： ${row.material}/颜色： ${row.color}/厚度： ${row.thick}/规格： ${row.spec}`
      }
    }
  },
  created() {
    this.isVip = this.userInfo.vip != 0;
    this.commodityColumns = commodityColumns(this.isVip);
    // let { goodsIds, sid } = this.$route.query;
    // if (!goodsIds) {
    //   this.$router.go(-1);
    //   return;
    // }
    let productInfo = window.sessionStorage.getItem('productInfo');
    if (productInfo) {
      productInfo = JSON.parse(productInfo)
    } else {
      this.$router.replace({
        name: 'Shop'
      })
    }
    // this.sid = sid;
    // let ids = (goodsIds + "").split(",");
    let ids = [productInfo.id];
    this.$post(
      "/py/erp/get_commodity_detail",
      {
        price_flag:'price',
        ids: ids,
      },
      (res) => {
        console.log("商品详情获取商品列表", res.data);
        this.com_infos.com_data = res.data;
        this.commodityList = res.data.map((v) => ({ ...v, count: 0 }));
        if (res.data.length > 0) {
          this.com_type = res.data[0].type;
          this.model_link = res.data[0].model_link;
          this.supplier_name = res.data[0].supplier_name;
          this.color_id = res.data[0].color_id;
          this.type = res.data[0].type;
          this.brand_name = this.com_infos.com_data[0].brand; //品牌
        }
        // if (this.com_type == "plank" || this.com_type == "hardware") {
        //   this.brand_name = this.com_infos.com_data[0].brand; //品牌
        // }
        // if (this.com_type == "edge") {
        //   this.edge_name = this.com_infos.com_data[0].supplier_name;
        // }
        // if (this.com_type == "door") {
        //   this.door_name = this.com_infos.com_data[0].name;
        // }

        this.remark = this.com_infos.com_data[0].remark; //备注
        this.link = this.com_infos.com_data[0].vr_url; //VR
        this.imgArr = this.commodityList.reduce((arr, next, i) => {
          let imgs = (next.color_picture||next.picture).map((v, j) =>
            typeof v === "string"
              ? {
                  id: +i + +j,
                  url: v,
                }
              : v
          );
          arr.push(...imgs);
          return arr;
        }, []);
        if (this.imgArr[0]) {
          this.imgUrl = this.imgArr[0].url;
          this.imgId = this.imgArr[0].id;
        }
      }
    );
    this.$post(
      "/guigui/cloudStorage/getSupplierInfo",
      {
        id: productInfo.supplierId,
      },
      (res) => {
        this.supplierMessage = res.data;
      }
    );
  },
};
</script>

<style lang="less" scoped>
.commodity-list{
  position: relative;
  .button_three_d{
    position: absolute;
    left: -150px;
    top: 350px;
    width: 130px;
    height: 45px;
    border-radius: 5px;
    border: 1px solid #000;
    font-size: 16px;
    cursor: pointer;
  }
}

.table-header {
  background: #f5f5f5;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #4d4d4d;
}
.table-cell {
  border-color: #d9d9d9;
  font-size: 15px;
}
.commodity_details_box {
  @orange: #f36800;
  .red {
    color: #f25e5e;
  }
  .orange {
    color: @orange;
  }
  .cursor {
    cursor: pointer;
  }
  text-align: left;
  width: 1440px;
  margin: 0 auto;

  .cloud_bread {
    font-size: 15px;
    color: #666;
    padding: 25px 0;
    .allHover:hover {
      color: #f36800;
    }
  }
  .goods_contend_box {
    display: flex;
    justify-content: space-between;
    .contend_left_box {
      position: relative;

      .VR_box {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 80px;
        height: 36px;
        line-height: 36px;
        border-radius: 18px;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.4);
        cursor: pointer;
        img {
          width: 28px;
          height: 28px;
        }
        span {
          font-size: 15px;
          color: rgba(255, 255, 255, 1);
          margin-left: 4px;
        }
      }
      .img_box {
        width: 418px;
        height: 418px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .img_indicator_box {
        width: 418px;
        ul {
          display: flex;
          justify-self: flex-start;
          flex-wrap: wrap;
          margin-bottom: 0;
          padding: 4px 20px;
          li {
            list-style: none;
            width: 54px;
            height: 54px;
            margin-right: 37px;
            margin-top: 16px;
            &.selected {
              border: 1px solid @orange;
            }
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              cursor: pointer;
            }
          }
          li:nth-child(5n) {
            margin-right: 0;
          }
        }
      }
    }
    .contend_middle_box {
      flex: 1;
      margin: 0 30px;
      > * {
        margin-top: 8px;
      }
      .commodity-info {
        background: #f5f5f5;
        color: #333;
        padding: 10px;
        font-family: PingFang SC;
        .commodity-info__name {
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          font-weight: bold;
          .to-order-fb {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #f36800;
            cursor: pointer;
          }
        }
        .commodity-info__inventory {
          font-size: 12px;
          font-weight: 400;
          .zy {
            display: inline-block;
            width: 32px;
            height: 16px;
            font-size: 11px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 16px;
            color: #b48b59;
            text-align: center;
            background: linear-gradient(180deg, #fce778 0%, #f9e131 100%);
            opacity: 1;
            border-radius: 6px;
          }
        }
        .commodity-info__price {
          > :nth-child(2) {
            display: inline-block;
            margin-left: 32px;
          }
          .price {
            font-size: 22px;
            font-family: PingFang SC;
            font-weight: bold;
            margin-left: 0;
            letter-spacing: 2px;
          }
        }
        .label {
          color: #838383;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
        }
        .commodity-info__item {
          .label;
          .content {
            display: inline-block;
            margin-left: 48px;
            color: #666;
          }
        }
      }
      .commodity-list {
        margin-top: 18px;
        border: 1px solid #d9d9d9;
      }
      .footer-hint {
        font-size: 14px;
        color: #666;
      }
      .control-btns {
        text-align: right;
        .btn {
          border-radius: 4px;
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          line-height: 28px;
          letter-spacing: 0 !important;
          border: none;
          cursor: pointer;
        }
        .to-cart {
          .btn;
          width: 120px;
          height: 40px;
          border: 1px solid #f36800;
          color: #f36800;
          letter-spacing: 60px;
          margin-right: 20px;
        }
        .addto-cart {
          .btn;
          width: 180px;
          height: 40px;
          background: #f36800;
          color: #ffffff;
          letter-spacing: 60px;
        }
      }
    }
    .contend_right_box {
      width: 216px;
      height: 331px;
      background-color: #ffffff;
      .contend_right_width {
        width: 184px;
        margin: 15px auto;
      }
      .supplier_box {
        display: flex;
        justify-content: flex-start;
        > div:nth-child(1) {
          width: 64px;
          height: 64px;
          margin-right: 8px;
          > img {
            width: 100%;
            height: 100%;
          }
        }
        > div:nth-child(2) {
          display: flex;
          flex-flow: column;
          span {
            font-size: rgba(51, 51, 51, 1);
            color: rgba(51, 51, 51, 1);
          }
          span:nth-child(2) {
            color: rgba(243, 104, 0, 1);
            margin-top: 10px;
          }
        }
      }
      .supplier_message_box {
        margin-top: 15px;
        margin-bottom: 15px;
        div {
          span {
            font-size: 12px;
            color: rgba(51, 51, 51, 1);
          }
        }
        div:nth-child(2) {
          margin-top: 15px;
        }
      }
      .supplier_goods_box {
        border-top: 1px solid rgba(235, 235, 235, 1);
        height: 65px;
        display: flex;
        justify-content: space-around;
        div {
          position: relative;
          top: 50%;
          transform: translateY(-50%);
        }
        div:not(:nth-child(2)) {
          height: 40px;
          display: flex;
          flex-flow: column;
          width: 60px;
          text-align: center;
        }
        .border_box {
          height: 40px;
          border: 1px solid rgba(235, 235, 235, 1);
        }
      }
      .to_shop_box {
        margin: 15px auto 0;
        border: 1px solid rgba(102, 102, 102, 1);
        width: 88px;
        height: 30px;
        line-height: 30px;
        border-radius: 14px;
        text-align: center;
      }
    }
  }
  .disabledBtn {
    pointer-events: none;
    color: rgba(0, 0, 0, 0.3);
    border: currentColor 1px solid !important;
    background-color: white;
    cursor: not-allowed !important;
    text-decoration: line-through;
  }
}
</style>
